import AGENCY_API from 'api/agency'
import { startSubmit, stopSubmit } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractViolations from 'utils/extractViolations'

function* loadData() {
  try {
    const { response, error } = yield call(AGENCY_API.fetchInfo)

    if (error) {
      throw error
    }

    yield put({ type: 'AGENCY/SET_DATA', payload: response.data })
  } catch (error) {
    yield put({ type: 'AGENCY/LOAD_DATA_FAILED' })
    console.logXHR(error)
  }
}

function* create({ payload }) {
  try {
    yield put(startSubmit('CreateAgencyForm'))
    
    const { response, error } = yield call(AGENCY_API.create, {
      data: payload,
    })

    if (error) {
      throw error
    }

    yield put({ type: 'AGENCY/SET_DATA', payload: response.data })
  } catch (error) {
    yield put(stopSubmit('CreateAgencyForm', extractViolations(error)))
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('AGENCY/LOAD_DATA', loadData)
  yield takeLatest('AGENCY/CREATE', create)
}
